import * as React from "react";
import { ResponsiveContainer, Tooltip, PieChart, Pie, Cell, Legend } from "recharts";
import { CustomTooltip } from "src/share/components/CustomTooltip/CustomTooltip";
import { GARequestor } from "./GARequestor";

export interface IGABrowsersProps {
  pagePath?: string;
  views: {
    query: {
      ids: string
    }
  }
}
const COLORS = ['#4284F4', '#67BCED', '#DCAD00'];

export const GABrowsers = (props: IGABrowsersProps) => {
  return (
    <GARequestor pagePath={props.pagePath} views={props.views} dimension={"ga:deviceCategory"}>
      {
        (data) => (
          <>
            <h5> Last 30 days</h5>
            <h6 className="subtitle">Views by device</h6>
            <ResponsiveContainer width={'90%'} height={310}>
              <PieChart>
                <Pie
                  cx="50%" cy="50%"
                  innerRadius={90}
                  outerRadius={120}
                  fill="#8884d8"
                  paddingAngle={5}
                  dataKey={'count'} data={data}  >
                  {
                    data.map((entry, index) => <Cell key={index} fill={data.length > 0 ? COLORS[index % COLORS.length] : "#F3F3F3"} />)
                  }
                </Pie>
                <Tooltip content={<CustomTooltip />} />
                <Legend align="center" verticalAlign="top" layout='horizontal' />
              </PieChart>
            </ResponsiveContainer>
          </>
        )
      }
    </GARequestor>
  )
}



// WEBPACK FOOTER //
// ./src/share/components/GoogleAnalitycs/GABrowsers.tsx